module.exports = __webpack_public_path__ + "static/media/star.a42acd46.png";